import React from 'react';

export const MeterKnobs: React.FC = () => <div>Knobs to come</div>;
